import React, { forwardRef } from 'react';
import { styled, Tooltip as MUITooltip, tooltipClasses, TooltipProps } from '@mui/material';
import { alpha } from '@mui/material/styles';

const Wrapper = styled(({ className, ...props }: TooltipProps) => (
    <MUITooltip
        {...props}
        classes={{ popper: className }}
    />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.primary.main,
        borderRadius: 0,
        padding: theme.spacing(2),
        maxWidth: 147,
        fontSize: 10,
    },

    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.primary.main,
    },
    [`&.table-sort-tooltip .MuiTooltip-tooltip`]: {
        backgroundColor: 'white',
        filter: 'drop-shadow(0px 0px 6px rgba(0, 0, 0, 0.1))',
        minWidth: 216,
        color: theme.palette.text.primary,
        [`.MuiFormControl-root,.MuiButtonBase-root,.MuiFormControlLabel-root`]: {
            width: '100%',
        },
        [`.MuiButtonBase-root`]: {
            width: 'auto',
        },
        [`.MuiTypography-root`]: {
            display: 'flex',
            alignItems: 'center',
        },
        [`.table-sort-tooltip-item`]: {
            paddingTop: theme.spacing(1.5),
            paddingLeft: theme.spacing(4),
            paddingBottom: theme.spacing(1.5),
            cursor: 'pointer',
            [`&:hover`]: {
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
            },
        },
    },
    [`&.table-sort-tooltip .MuiTooltip-arrow`]: {
        color: 'white',
    },
    [`&.table-sort-tooltip .MuiRadio-root`]: {
        color: alpha(theme.palette.primary.main, 0.5),
    },
    [`&.table-sort-tooltip .MuiRadio-root.Mui-checked`]: {
        color: theme.palette.primary.main,
    },
}));

export const Tooltip = forwardRef((props: TooltipProps, ref) => {
    const { children, ...rest } = props;

    return (
        <Wrapper
            {...rest}
            ref={ref}
            arrow
        >
            <div>{children}</div>
        </Wrapper>
    );
});

Tooltip.displayName = 'Tooltip';
